import type { ThemeUICSSObject } from 'theme-ui';

type ExtraTabGroupStyles =
	| {
			sticky?: boolean;
			stickyPos?: number;
	  }
	| undefined;

// eslint-disable-next-line @typescript-eslint/naming-convention
export function baseTabStyles(__internal_selected?: boolean): ThemeUICSSObject {
	return {
		borderBottom: '4px solid',
		borderColor: __internal_selected ? 'primary-changeRed' : 'transparent',
		color: __internal_selected ? 'typography-highlight' : 'typography-primary',
		flexShrink: -0,
		pb: 8,
		textAlign: 'center',
		whiteSpace: 'nowrap',
		px: 16,
	};
}

export function baseTabGroupStyles(extraInfo?: ExtraTabGroupStyles): ThemeUICSSObject {
	const { sticky, stickyPos } = extraInfo || {};
	return {
		position: sticky ? 'sticky' : 'relative', // needed to appear on top of the rule
		background: sticky ? 'white' : '',
		display: 'inline-flex',
		flexDirection: 'column',
		width: '100%',
		top: stickyPos ?? 0,
		zIndex: 1,
	};
}

export function baseTabRuleStyles(): ThemeUICSSObject {
	return {
		position: 'absolute',
		borderBottom: '1px solid',
		borderColor: 'neutral-grey100',
		flexGrow: 1,
		bottom: 0,
		width: '100%',
	};
}

export function baseTabGroupListStyles({ spreadTabs }: { spreadTabs?: boolean }): ThemeUICSSObject {
	return {
		position: 'relative', // needed to appear on top of the rule
		display: 'inline-flex',
		listStyleType: 'none',
		px: 0,
		width: '100%',
		whiteSpace: 'nowrap',
		overflowX: 'auto',
		overflowY: 'hidden',
		// eslint-disable-next-line @typescript-eslint/naming-convention
		'::-webkit-scrollbar': {
			display: 'none',
		},
		// eslint-disable-next-line @typescript-eslint/naming-convention
		'& > *': {
			flexGrow: spreadTabs ? 1 : undefined,
		},
	};
}
